import { HTTPService } from 'fides-angularjs-components/src/fts-services/fts-http-service';
import { PortalService } from "fides-angularjs-components/src/fts-administration/services/fts-portal-service";
import { ACCOUNT_ACCESS, USER_ACC } from "../../services/arsweb/RoutingPaths";

/* @ngInject */
export class fsLoginController {

    /* @ngInject */
    constructor(userService) {
        this.userService = userService;
        this.fsMainDependencies = userService.fsMainDependencies;
        this.$log = this.fsMainDependencies.$log;
        this.portalService = new PortalService(this.fsMainDependencies);
        this.fsMainDependencies.initCompletedPromise = this.fsMainDependencies.$rootScope.user ?
          Promise.resolve() : this.portalService.appService.automaticLogin();
    }

    logout() {
        new HTTPService(this.fsMainDependencies).delete(USER_ACC + ACCOUNT_ACCESS).then(() => {
            this.$log.info("Auth token deleted");
        });
        this.portalService.appService.redirectToPortal();
    }
}
